var transformSlideProps = function (_a, urlParams) {
    var image = _a.image, name = _a.name, shortName = _a.shortName, redirectUrl = _a.redirectUrl, urlPath = _a.urlPath;
    return ({
        link: "" + (redirectUrl || urlPath) + urlParams,
        description: shortName || name,
        image: image,
    });
};
export var transformProductListProps = function (data, urlParams) {
    if (data === null || data === void 0 ? void 0 : data[0]) {
        var list = [];
        if ('navigation' in data[0]) {
            list = data[0].navigation.items.list;
        }
        else if ('items' in data[0]) {
            list = data[0].items.list;
        }
        return list
            .filter(function (_a) {
            var articleCount = _a.articleCount;
            return articleCount > 0;
        })
            .map(function (item) { return transformSlideProps(item, urlParams); });
    }
    return [];
};
